//@flow
import { styled } from 'linaria/react';
import type { Context } from './index.h';
import { theme } from './theme/default';
/**
 * Return themed log-method style
 * @param style The style
 * @param type The method
 */

const Themed = (style: string, method: string, styles) => styles[`LOG_${method.toUpperCase()}_${style.toUpperCase()}`] || styles[`LOG_${style.toUpperCase()}`];

type Props = {|
  theme: Context
|};
const {
  styles
} = theme;
/**
 * console-feed
 */

export const Root =
/*#__PURE__*/
styled("div")({
  name: "Root",
  class: "ry08aaw"
});
/**
 * console-message
 */

export const Message =
/*#__PURE__*/
styled("div")({
  name: "Message",
  class: "m1cjvls3",
  vars: {
    "m1cjvls3-0": [props => +/^warn|error$/.test(props.method)],
    "m1cjvls3-1": [props => Themed('color', props.method, styles)],
    "m1cjvls3-2": [props => Themed('background', props.method, styles)],
    "m1cjvls3-3": [props => Themed('border', props.method, styles)]
  }
});
/**
 * message-icon
 */

export const Icon =
/*#__PURE__*/
styled("div")({
  name: "Icon",
  class: "i1gscq2u",
  vars: {
    "i1gscq2u-0": [props => Themed('icon', props.method, styles)]
  }
});
/**
 * console-content
 */

export const Content =
/*#__PURE__*/
styled("div")({
  name: "Content",
  class: "c14mu766"
});